import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const minutesAgo = useRef<number[]>(purchaseNotifications.map(() => Math.floor(Math.random() * 12) + 1));
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    const hideTimer = window.setTimeout(() => {
      setVisible(true);
      showTimer = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [index, dismissed]);
  useEffect(() => {
    if (visible || dismissed) return;
    const next = window.setTimeout(() => {
      setIndex(prev => (prev + 1) % purchaseNotifications.length);
    }, 400);
    return () => window.clearTimeout(next);
  }, [visible, dismissed]);
  const person = purchaseNotifications[index];
  return <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-4 sm:justify-start sm:px-6 sm:pb-6" data-id="element-167" data-mp="1fxvapeos2xog">
      <AnimatePresence data-id="element-168" data-mp="n6lhhid87qs5">
        {visible && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} role="status" aria-live="polite" className="pointer-events-auto relative flex w-full max-w-sm items-start gap-3 rounded-xl border border-line bg-ink-800 p-3 pr-9 shadow-2xl shadow-black/60" data-id="element-169" data-mp="n97ptk7xyabf">
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent/15 text-accent" data-id="element-170" data-mp="23nh9w255hcwg">
              <CheckCircle2Icon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="2fne8de846oq8" />
            </span>
            <div className="min-w-0" data-id="element-172" data-mp="2kmr5qswm3e72">
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-173" data-mp="2knskp8gr0ku2">
                {person.name} just bought Baseball 360
              </p>
              <p className="mt-0.5 text-xs text-slate-400" data-id="element-174" data-mp="2pjhkncwok3qw">
                {person.location} · {minutesAgo.current[index]} min ago · Complete Vault
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded p-1 text-slate-500 transition-colors duration-150 ease-snap hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-175" data-mp="1wxg5rdn35ntz">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="1e5natdoghsjm" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}